import { DateStr, GetPntScheduleDto, Paginated, Station, now, toDateStr } from '@mi-front/core';
import { apiClient } from '../../../../../../api';
import { ReportView } from '../../../../../../core/reports/components/ReportView';
import { ReportType } from '../../../../../../core/reports/types';
import { SchedulesListMentionsIndexForm } from './form';
import { SchedulesListMentionsIndexResult } from './result';

type Props = {
  station: Station;
};

export type SchedulesMentionsIndexListing = ReportType<
  { date: DateStr },
  Paginated<GetPntScheduleDto>
>;

export function MentionsIndexView(p: Props) {
  return (
    <ReportView<SchedulesMentionsIndexListing>
      defaultValues={{
        date: toDateStr(now()),
      }}
      runOnLoad
      download={false}
      reportFn={async (values) => {
        return apiClient.audit.fetchMentionsDateSchedules({
          ...values,
          stationId: p.station.id,
          filter: {
            date: values.date,
          },
        });
      }}
      Form={SchedulesListMentionsIndexForm}
      Result={SchedulesListMentionsIndexResult}
    />
  );
}
